import * as React from "react";
import { centerCenter } from "csstips";

import { classes, style } from "typestyle";
import { Route } from "react-router";
import { BrowserRouter, Switch } from "react-router-dom";

import { getBackgroundImgUrl } from "../backgrounds";
import { SigninPage } from "./pages/SigninPage";
import { RecoveryPage } from "./pages/RecoveryPage";
import { SetNewPasswordPage } from "./pages/SetNewPasswordPage";

import { SigninPageAnalytics } from "../libs/analytics/SigninPageAnalytics";
import InspectletUtils from "../libs/InspectletUtils";

import { getParameterFromQueryString } from "../querystring-util";
import {
  getLoginService,
  initLoginService
} from "../login-service/LoginService";
import { TermsOfUse, TermsOfUsePage } from "./pages/TermOfUsePage";

interface IAppState {
  refererUrl: string;
  defaultEmail: string;
  accessToken: string;
  termsOfUse: TermsOfUse | null;
}

export class App extends React.Component<{}, IAppState> {
  constructor(props: {}) {
    super(props);

    const refererUrl = getParameterFromQueryString(
      window.location.href,
      "referer"
    );
    const decodedRefererUrl = refererUrl ? decodeURIComponent(refererUrl) : "";
    this.state = {
      refererUrl,
      defaultEmail:
        getParameterFromQueryString(decodedRefererUrl, "email") || "",
      accessToken:
        getParameterFromQueryString(decodedRefererUrl, "accessToken") || "",
      termsOfUse: null
    };

    if (ANALYTICS_ENABLED && ANALYTICS_BACKEND_URL) {
      SigninPageAnalytics.setup(ANALYTICS_ENABLED, ANALYTICS_BACKEND_URL, ENV);
    }
    if (INSPECTLET_ENABLED && INSPECTLET_ID) {
      InspectletUtils.init(INSPECTLET_ID);
    }

    initLoginService(
      getParameterFromQueryString(window.location.href, "loginServiceBaseUrl")
    );
  }

  async componentDidMount() {
    const ToU = await getLoginService().getLatestTermsOfUse();
    this.setState({ termsOfUse: ToU?.termsOfUse || null });
  }

  render() {
    const { refererUrl, defaultEmail, accessToken, termsOfUse } = this.state;
    return (
      <div className={classes(appStyle)}>
        <BrowserRouter>
          <Switch>
            <Route
              path="/"
              exact
              render={({ history }) => (
                <SigninPage
                  history={history}
                  accessToken={accessToken}
                  defaultEmail={defaultEmail}
                  refererUrl={refererUrl}
                />
              )}
            />
            <Route
              path="/recovery"
              render={({ history }) => (
                <RecoveryPage
                  defaultEmail={defaultEmail}
                  history={history}
                  refererUrl={refererUrl}
                />
              )}
            />
            <Route
              path={PASSWORD_RECOVERY_CONFIRMATION_ROUTE}
              render={({}) => <SetNewPasswordPage refererUrl={refererUrl} />}
            />
            {termsOfUse !== null && (
              <Route
                path="/terms-of-use"
                render={({ history }) => (
                  <TermsOfUsePage
                    history={history}
                    termsOfUse={termsOfUse}
                    refererUrl={refererUrl}
                  />
                )}
              />
            )}
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

const appStyle = style({
  ...centerCenter,
  alignItems: "start",
  width: "100%",
  height: "100%",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundImage: `url(${getBackgroundImgUrl()})`
});
